import { useEventItemLoadingDisplay } from 'src/hooks/useEventItemLoadingDisplay';
import { ModalProps } from 'src/modals/Modal';
import { FormatContentId } from 'src/utils/constants/formatContentId';
import { EntityWithRealTickets } from 'src/utils/ticketUtils';

import { UploadTicketUrlsContent } from './UploadTicketUrls';

export type ViewTicketUrlModalProps = {
  cancelTo?: ModalProps;
  defaultToBulk?: boolean;
  isReadOnly?: boolean;
  loadingContentId: FormatContentId;
  searchingContentId: FormatContentId;
  errorContentId: FormatContentId;
};

export const ViewTicketUrls = ({
  cancelTo,
  loadingContentId,
  searchingContentId,
  errorContentId,
}: ViewTicketUrlModalProps) => {
  const { loadingState } = useEventItemLoadingDisplay<EntityWithRealTickets>(
    loadingContentId,
    searchingContentId,
    errorContentId
  );

  return (
    loadingState || <UploadTicketUrlsContent cancelTo={cancelTo} isReadOnly />
  );
};
